import React from 'react'
import { Skeleton } from 'antd'

export const generateSkeletonRows = (count = 5) => {
  const rows = []
  for (let i = 0; i < count; i++) {
    rows.push({
      key: `skeleton-${i}`,
      _id: `skeleton-${i}`,
      skeleton: true
    })
  }
  return rows
}

export const generateSkeletonColumns = (actualColumns) => {
  return actualColumns.map((col) => ({
    ...col,
    render: () => (
      <div style={{ width: '100%', overflow: 'hidden' }}>
        <Skeleton.Input
          active
          size='small'
          style={{
            width: '100%',
            minWidth: col.width || 100,
            maxWidth: col.width || '100%'
          }}
        />
      </div>
    ),
    onCell: () => ({
      style: {
        cursor: 'default',
        padding: '8px',
        maxWidth: col.width || 'auto'
      }
    })
  }))
}
